import React, { useRef, useState } from "react";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ReactPasswordChecklist from "react-password-checklist";
import svgone from "../../../assets/svg/svgone.svg";
import toast from "react-hot-toast";
import {
  cleanForgotAcc,
  cleanSingleUser,
  logout,
  save,
} from "../../../features/auth/authSlice";
import InsideHeader from "../../../components/InsideHeader";
import { clearDropObj, resetPassword } from "../../../features/dropdown/dropdownSlice";
import { clearFolderObj } from "../../../features/folder/folderSlice";
import { clearSaveObj } from "../../../features/save/saveSlice";
import { clearStaffObj } from "../../../features/staff-setting/staffSettingSlice";

export default function PasswordMngt() {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading} = useSelector((state) => state.dropdown);

  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  async function handleLogout() {
    // e.preventDefault();
    await dispatch(logout());
    await dispatch(clearDropObj());
    await dispatch(clearFolderObj());
    await dispatch(clearSaveObj());
    await dispatch(clearStaffObj());
    await localStorage.clear();
    await navigate("/login");
  }

  const onFinish = async () => {
    const isPasswordValid =
      password.length >= 8 &&
      /\d/.test(password) &&
      /[A-Z]/.test(password) &&
      /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]+/.test(password) &&
      password === confirmPassword;
    if (!isPasswordValid) {
      toast.error(
        "Password does not meet the required conditions or does not match"
      );
      return;
    }

    const res = await dispatch(
      resetPassword({
        oldUsrEncryptedPassword:currentPassword,
        newUsrEncryptedPassword: password, 
      })
    );
    if (res?.payload?.success) {
      await toast.success(res.payload?.messages?.message);
      await handleLogout();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  return (
    <>
      <div className="w-full h-full overflow-y-scroll">
        {/* <InsideHeader
          title="Set new password"
          subtitle="Set a secure password"
          back={false}
        /> */}
        <div className="flex flex-col items-center w-full bg-white rounded-[10px] mt-[1.25rem] h-full lg:px-10 px-3">
        <h3 className="heading_1 mt-10">Set new password</h3>
            <span className="zambia_login_text mt-[.75rem]">
              Set a secure password
            </span>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="mt-[.75rem] max-w-full lg:w-[500px] w-full"
            form={form}
          >
            <Form.Item
              label="Current Password"
              className="login-form-item"
              name="oldUsrEncryptedPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="input-login-password"
                type="password"
              />
            </Form.Item>
            <Form.Item
              label="Password"
              className="login-form-item"
              name="usrEncryptedPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setPassword(e.target.value)}
                className="input-login-password"
                type="password"
              />
            </Form.Item>

            <Form.Item
              label="Confrim password"
              className="login-form-item"
              name="usrEncryptedPasswordAlt"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input-login-password"
                type="password"
              />
            </Form.Item>

            <span>
              To protect your account, we require that your password has;
            </span>

            <div className="mt-[.32rem]">
              <ReactPasswordChecklist
                className="text-darkBlue"
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                messages={{
                  minLength: "A minimum of 8 characters",
                  number: "At least one number (0-9)",
                  capital: "At least one upper case letter (A-Z)",
                  match: "Confirm password to match with the password",
                  specialChar:
                    "At least one special character e.g !@#$%^&*()_+{}[]:;?/|\\",
                }}
                iconComponents={{
                  ValidIcon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6 text-darkBlue"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  ),
                  InvalidIcon: (
                    <img className="pr-[.5rem]" src={svgone} alt="lazy" />
                  ),
                }}
                validColor="#147CBC"
                iconSize={2}
              />
            </div>

            <button
              disabled={loading}
              className="cstm-btn mt-[2.75rem]"
              type="submit"
            >
              {loading ? <Spin /> : "Update"}
            </button>
          </Form>
        </div>
      </div>
    </>
  );
}
